import React from "react";
import { AlertTriangle, Bot, RotateCcw, ShieldAlert, PlayCircle, Square } from "lucide-react";
import { Button } from "../ui/button";
import { useEmployerTrainingCoach, useEmployerTrainingSession } from "./EmployerModeContext";

export default function EmployerTrainingChrome() {
  const {
    currentRun,
    scenarios,
    resumeTraining,
    restartTraining,
    endTraining,
    loading,
    error,
  } = useEmployerTrainingSession();
  const { coachOpen, setCoachOpen } = useEmployerTrainingCoach();

  if (!currentRun || currentRun.status !== "active") return null;

  const selectedScenario = scenarios.find((entry) => entry.key === currentRun.scenario_key) || null;

  return (
    <div className="employer-training-chrome">
      <div className="employer-training-badge">
        <ShieldAlert size={16} strokeWidth={2} />
        <span>Trainingsmodus</span>
      </div>

      <div className="employer-training-banner">
        <div className="employer-training-banner__copy">
          <p className="employer-training-banner__title">
            Training auf echter Employer-UI
          </p>
          <p className="employer-training-banner__text">
            Keine echten Bewerber, keine echten Nachrichten, keine echte Behoerdenabgabe.
            {" "}
            Szenario: <strong>{selectedScenario?.label || currentRun.scenario_key}</strong>
            {" "}
            auf Anzeige <strong>#{currentRun.job_ad_snapshot?.id}</strong>.
          </p>
          <p className="employer-training-banner__meta">
            Stage {currentRun.current_stage} · Letzte Aktion {currentRun.last_action_key || "training_started"}
          </p>
          {error ? <p className="employer-training-banner__error">{error}</p> : null}
        </div>

        <div className="employer-training-banner__actions">
          <Button type="button" variant="outline" className="dashboard-inline-button" onClick={() => setCoachOpen((current) => !current)} disabled={loading}>
            <Bot className="mr-2 h-4 w-4" />
            {coachOpen ? "Coach einklappen" : "Coach oeffnen"}
          </Button>
          <Button type="button" variant="outline" className="dashboard-inline-button" onClick={resumeTraining} disabled={loading}>
            <PlayCircle className="mr-2 h-4 w-4" />
            Fortsetzen
          </Button>
          <Button
            type="button"
            variant="outline"
            className="dashboard-inline-button"
            onClick={() => restartTraining(currentRun.scenario_key)}
            disabled={loading}
          >
            <RotateCcw className="mr-2 h-4 w-4" />
            Neu starten
          </Button>
          <Button type="button" variant="outline" className="dashboard-inline-button" onClick={endTraining} disabled={loading}>
            <Square className="mr-2 h-4 w-4" />
            Beenden
          </Button>
        </div>
      </div>

      <div className="employer-training-disclaimer">
        <AlertTriangle size={14} strokeWidth={2} />
        <span>Alle Requests, Filing-Schritte und Pack-Aktionen bleiben in einer isolierten Sandbox.</span>
      </div>
    </div>
  );
}
